import './setup.js';
import '../styles.css';
import './bootstrap-components.js';
import { mountApp } from './App.jsx';

mountApp();
